import React, { useEffect, useState, useReducer } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import { labels } from '../../../util/utils';
import _ from 'lodash';
import { loggedInUserRoleCheckSelector } from '../../ManageTeams/teamUserSelector';
import { serviceURL, UserLookupType } from '../../../util/uiconstants';
import Modal from '../../Common/Modal/Modal';
import AddMember from '../../ManageTeams/AddMember';
import ErrorSummary from '../../Common/ErrorSummary/ErrorSummary';
import { setIsModalOpen } from '../../../actions/AccessGroups/SetIsModalOpen';
import { getProjectAccessGroups } from '../../../actions/AccessGroups/Accessgroupactions';
import env from '../../../util/env';
import { raiseJSValidationError, clearErrors, raiseMultipleJSValidationError } from '../../../actions/erroractions';
import { initialstate } from '../../Pages/CreateProjectClassic/AddNewGroup/Helper/initialstate';
import { GroupContext } from '../../Pages/CreateProjectClassic/AddNewGroup/Helper/GroupContext';
import reducer from '../../Pages/CreateProjectClassic/AddNewGroup/Helper/GroupReducer';
import useDetailsSelector from '../Common/Hooks/GetDetailsHook';

const AddMemberGroup = (props) => {
	const [selectedMember, setSelectedMember] = useState(null);
	const [selectedGroups, setSelectedGroups] = useState(undefined);
	const [clearUserData, setClearUserData] = useState(false);
	const [showUserError, setShowUserError] = useState(false);
	const [showGroupError, setShowGroupError] = useState(false);
	const [isDuplicateUser,setIsDuplicateUser] = useState(false);
	const userPreferences = useSelector((store) => store.userPreferences);
	const projectAccessGroups = useSelector((store) => store.projectTeam.accessGroups);
	const projectUsers = useDetailsSelector('users');

	const [state, localdispatch] = useReducer(reducer, initialstate);
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(clearErrors());
		if (!projectAccessGroups || projectAccessGroups.length === 0) {
			loadGroups();
		}
	}, []);

	const loadGroups = () => {
		let url = `${env.getBaseURL(serviceURL)}Projects/${props.projectId}/Groups`;
		dispatch(getProjectAccessGroups(url));
	};

	const onSelectedGroupChange = (selectedGroupParam) => {
		setSelectedGroups(selectedGroupParam);
		setShowGroupError(false);
	};

	const addMemberToGroups = (closeModal) => {
		let isValidaData = true;
		setClearUserData(false);
		setShowUserError(false);
		if (!selectedGroups || selectedGroups.length === 0) {
			setShowGroupError(true);
			isValidaData = false;
		} else {
			setShowGroupError(false);
		}

		if (!selectedMember || !selectedMember.firstName || !selectedMember.lastName) {
			setShowUserError(true);
			isValidaData = false;
		} else {
			setShowUserError(false);
		}

		if(isValidaData 
			&& ((projectUsers && projectUsers.some(u=>u.userId==selectedMember.userId && u.isProjectOwner==true) ) || 
			(props.addedMembers && props.addedMembers.some(u=>u.userId==selectedMember.userId)))){
			isValidaData = false;
			setIsDuplicateUser(true);
			setShowUserError(true);
		}else {
			setShowUserError(false);
		}

		if (isValidaData) {
			const selectedGroupIds = selectedGroups.map((a) => a.id);
			//props.setSelectedGroupIds(selectedGroupIds);
			var selectedGroupMembers = [...props.selectedGroupMembers];
			var groupIds = selectedGroupMembers.map(function(e) { return e.groupId; })
			_.forEach(selectedGroupIds, (groupId) => {
				var existingGroupIndex = groupIds.indexOf(groupId);
				if(existingGroupIndex > -1)
				{
					selectedGroupMembers[existingGroupIndex]?.users?.push(selectedMember);
				}
				else
				{
					selectedGroupMembers.push({groupId: groupId, users : [selectedMember]})
				}
			});
			props.setSelectedGroupMembers(selectedGroupMembers);
	
			hideModal();
		}
	};

	const hideModal = () => {
		setSelectedGroups(undefined);
		setSelectedMember(null);
		setClearUserData(true);
		dispatch(clearErrors()).then(() => {
			dispatch(setIsModalOpen(false));
		});
		props.hideAddMemberModal(true);
	};

	return (
		<GroupContext.Provider value={{ state: state, dispatch: localdispatch }}>
			<StyledAddUpdateMemberGroup>
				<Modal
					show={true}
					showButtons={true}
					modalsize={'medium'}
					title={labels.addAMember}
					onHide={hideModal}
					closeTitle={labels.closeLabel}
					modalContainerClass="add-member-modal"
					confirmBtnTitle={labels.add}
					onOkClick={() => addMemberToGroups(true)}
					closeBtnTitle={labels.cancelLabel}
				>
					<ErrorSummary />
					<AddMember
						key={'addmember'}
						projectId={props.projectId}
						loggedInUserGui={userPreferences && userPreferences.gui}
						setSelectedGroups={onSelectedGroupChange}
						isUserProjectOwner={props.isOversightAdmin}
						selectedGroups={selectedGroups}
						showUserError={showUserError}
						showGroupError={showGroupError}
						isDuplicateUser = {isDuplicateUser}
						duplicateUserMessage = {labels.duplicateUserMessage}
						clearData={clearUserData}
						userData={props.userData}
						setSelectedMember={setSelectedMember}
						isEdit={false}
						canClearSelectedValue={true}
						isAdminAddMember={true}
						isNameEditable={true}
					></AddMember>
				</Modal>
			</StyledAddUpdateMemberGroup>
		</GroupContext.Provider>
	);
};

export default AddMemberGroup;

const StyledAddUpdateMemberGroup = styled.section`
	width: 100%;
	height: 100%;
	background: ${(props) => props.theme.color['white']};
	.add-member-btn {
		width: 10rem;
	}
	.team-user-list-wrapper {
		height: 100%;
		padding: 0 4rem;

		&.group-table {
			.list-body {
				.row-cell-1 {
					width: 45%;
				}
			}
		}
		.motif-card {
			border: 0;
			display: flex;
			.motif-card-header {
				padding: 2rem 0 !important;
				.header-element {
					width: 100%;
					display: flex;
					align-items: center;
				}
			}
			.motif-search-input-wrapper {
				background-color: ${(props) => props.theme.color['grey100']};

				.motif-input {
					height: 3.5rem !important;
				}
			}
			.motif-card-body {
				flex-grow: unset;
				height: calc(100% - 8.6rem);
				.table-header {
					background: ${(props) => props.theme.color['grey100']};
					border-bottom: 0.1rem solid ${(props) => props.theme.color['grey250']};
					padding: 0 1rem;
					// @media only screen and (min-width: 1280px) and (max-width: 1365px) {
					// 	.table-header-col-0{
					// 		width: 49.5%;
					// 	}
					// }
				}
				.table-body {
					height: calc(100% - 4.5rem);
					& > div {
						height: 100%;
						.list-body {
							height: calc(100% - 7.8rem);
							.table-row {
								border-bottom: 0.1rem solid ${(props) => props.theme.color['grey200']};
								height: 6.7rem;
								padding: 0 1rem;
							}

							// .row-cell-1{
							// 	width: 45%;
							// }
						}
						.list-body-pagination {
							.motif-dropdown-menu {
								.motif-pagination-select-menu {
									top: unset !important;
									bottom: 4rem !important;
								}
							}
						}
					}
				}
			}
		}
	}
	.milestone-select {
		width: 28.5rem;
		margin-right: 2rem;
	}
	.user-details-container {
		width: 30rem;
		position: relative;
		.userimg {
			border-radius: 10rem;
			background: ${(props) => props.theme.color[`green600`]};
			margin-right: 0.8em;
			color: ${(props) => props.theme.color[`white`]};
			min-width: 4rem;
			height: 4rem;
			text-align: center;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 1.4rem;
		}
		.admin-badge {
			position: absolute;
			top: 0.5rem;
			right: -6rem;
		}
		mgt-person {
			width: 100%;
			.line1 {
				color: ${(props) => props.theme.color[`black`]};
			}
		}
		.userdata {
			// width: 100% !important;
			&.ms-user {
				.user-avatar,
				.img-wrapper {
					width: 4rem;
					height: 4rem;
				}
				.user-presence {
					top: 3.5rem;
				}
				.userEmail {
					opacity: 1;
					color: ${(props) => props.theme.color[`grey400`]};
					font-weight: 300;
				}
			}
		}
		.userInfoDetails {
			width: 100%;
			.userName {
				width: 95%;
				max-width: 95% !important;
			}
		}
	}
	.groups-tooltip-container,
	.entities-tooltip-container {
		padding-left: 0.2rem;
	}
	.action-icons-container {
		width: 100%;
		display: flex;
		justify-content: flex-end;
		.action-icon {
			height: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			.motif-icon {
				height: 1.5rem;
				width: 1.5rem;
				transition: ease-in-out 0.2s opacity;
				&:hover {
					opacity: 1;
				}
			}
		}
	}
	.indicator {
		display: inherit;
		align-items: inherit;
		.motif-icon {
			display: inherit;
			margin-left: 0.5rem;
			svg {
				width: 2rem !important;
				fill: ${(props) => props.theme.color['red600']};
				cursor: default;
			}
		}
	}
`;
